const priceCoinWidget = {
    initEvents() {
        $('.coin-list .expand-block').click(function () {
            const parent = $(this).closest('.coin-list')[0];
            $(parent).toggleClass('open-list');

            const changeTextEl = $(this).find('[data-change-text]').get(0);

            if ($(parent).hasClass('open-list')) {
                changeTextEl.textContent = changeTextEl.dataset.collapseText;
            } else {
                changeTextEl.textContent = changeTextEl.dataset.expandText;
            }
        });
    },

    init() {
        this.initEvents();
    }
}

export default priceCoinWidget;
